import { mergeMap, withLatestFrom } from 'rxjs/operators';
import { IEpic, isTypeOfAndGetPayload } from '@cbridge-utils/redux-observable';
import { IGetSelectorStateType } from '@cbridge-utils/reselect';
import { ScheduleIntervalAction, makeIntervalId } from '@cbridge-packages/schedule-interval';
import { detailsSidebarResourceIdSelector } from '@cbridge-packages/details-sidebar';
import { RouterAction, withSkipUnsavedChangesConfirmation } from '@cbridge-packages/routing';
import { generateScheduleProfileRoute } from '@cbridge-packages/routing-client-admin';

type IState = IGetSelectorStateType<typeof detailsSidebarResourceIdSelector>;

export const closeScheduleIntervalBeforeRemoveEpic: IEpic<IState> = (action$, state$) => action$.pipe(
  isTypeOfAndGetPayload(ScheduleIntervalAction.remove.started),
  withLatestFrom(state$),
  mergeMap(([payload, state]) => {
    const { scheduleId, index } = payload;
    const openedDetailsId = detailsSidebarResourceIdSelector(state);

    if (makeIntervalId(scheduleId, index) === openedDetailsId) {
      return [
        RouterAction.replace([generateScheduleProfileRoute(), withSkipUnsavedChangesConfirmation()]),
      ];
    }

    return [];
  }),
);
